import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import { DSAssetFamilyToObjectType } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilyMappings';
import { Map as ImmutableMap } from 'immutable';
import { CustomObjectTypeIdRegex } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { useCallback, useContext, useMemo } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { makeAtom } from 'atom';
import { hasSiteContentAccess } from 'customer-data-filters-ui/permissions/scopes';
import { operatorSupportsExternalOptions } from 'customer-data-filters-ui/utils/operatorSupportsExternalOptions';
import { getPropertyResolver } from 'reference-resolvers-lite/utils/getPropertyResolver';
import { isExternalOptionsField } from 'customer-data-filters-ui/utils/isExternalOptionsField';
import FieldResolverNull from 'customer-data-filters-ui/filterQueryFormat/knownOptionResolvers/FieldResolverNull';
import PropertyNameToReferenceType from 'customer-data-objects/property/PropertyNameToReferenceType';
import getIn from 'transmute/getIn';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import AllObjectPropertiesReferenceResolver from 'reference-resolvers/resolvers/AllObjectPropertiesReferenceResolver';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import PropertyGroupRecord from 'customer-data-objects/property/PropertyGroupRecord';
import I18n from 'I18n';
import * as FiltersReferenceObjectTypes from 'customer-data-filters-ui/constants/FiltersReferenceObjectTypes';
import { NONE } from '../filterQueryFormat/timestamps/TimestampTypes';
import { StringDisplayType } from '../filterQueryFormat/DisplayTypes';
import MissingField from '../filterQueryFormat/MissingField';
import { hasFieldOverrideV2 } from '../permissions/gates';
import { ASSOCIATION_DIRECTION } from '../filterQueryFormat/associations/AssociationUtilities';
import { isObjectsAssociationOptionsGroup } from '../types/ObjectsAssociationOptions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { TEAM as TeamReferenceObjectType } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { TEAM as TeamExternalOptionType } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
const dynamicResolvers = {};
const alphabetizeAssociationOptions = options => {
  if (!options) {
    return undefined;
  }
  return options.map(option => {
    if (isObjectsAssociationOptionsGroup(option)) {
      return Object.assign({}, option, {
        options: option.options.sort((a, b) => {
          const aText = a.text || a.value;
          const bText = b.text || b.value;
          return aText.localeCompare(bText);
        })
      });
    }
    return option;
  });
};
export function useStrategy() {
  const {
    data,
    fetchMore,
    getIsUngated,
    hasScope,
    selectedObjectType: selectedObjectTypeState,
    props: {
      baseFilterFamily,
      strategy,
      resolvers
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const selectedObjectType = useMemo(() => selectedObjectTypeState || {
    filterFamily: baseFilterFamily,
    isObjectOwnFilterBranch: true
  }, [baseFilterFamily, selectedObjectTypeState]);
  const strategyProps = useMemo(() => ({
    baseFilterFamily,
    data,
    isAssociation: !selectedObjectType.isObjectOwnFilterBranch,
    hasScope,
    getIsUngated,
    fetchMore
  }), [baseFilterFamily, data, hasScope, getIsUngated, fetchMore, selectedObjectType]);
  const getEnabledAssociatedObjectTypeIds = useCallback(() => {
    if ('getEnabledAssociatedObjectTypeIds' in strategy) {
      return strategy.getEnabledAssociatedObjectTypeIds(strategyProps, strategy.isSameObjectAssociationFilteringEnabled);
    }
    return [];
  }, [strategyProps, strategy]);
  const getFieldGroups = useCallback(filterFamily => strategy.getFieldGroups(filterFamily, strategyProps), [strategyProps, strategy]);
  const getRefinementFieldGroups = useCallback(filterFamily => strategy.getRefinementFieldGroups(filterFamily, strategyProps), [strategyProps, strategy]);
  const getField = useCallback((filterFamily, id) => {
    const defaultField = MissingField({
      name: `${id}`,
      timestampType: NONE,
      type: StringDisplayType
    });
    return strategy.getField(filterFamily, id, defaultField, strategyProps);
  }, [strategy, strategyProps]);
  const getFields = useCallback(filterFamily => strategy.getFields(filterFamily, strategyProps), [strategyProps, strategy]);
  const getRequiredFields = useCallback(filterFamily => strategy.getRequiredFields(filterFamily), [strategy]);
  const getFilterFamilyGroupHeading = (filterFamily, associationId, isEditor, isSameObjectAssociation = false) => strategy.getFilterFamilyGroupHeading(filterFamily, associationId, isEditor, strategyProps, selectedObjectType, strategy.isSameObjectAssociationFilteringEnabled, isSameObjectAssociation);
  const getFilterFamilyName = (filterFamily, isSameObjectAssociation = false) => strategy.getFilterFamilyName(filterFamily, strategyProps, selectedObjectType, strategy.isSameObjectAssociationFilteringEnabled, isSameObjectAssociation);
  const getFilterFamilyObjectName = useCallback((filterFamily, isPlural = false) => strategy.getFilterFamilyObjectName(filterFamily, selectedObjectType, strategy.isSameObjectAssociationFilteringEnabled, strategyProps, isPlural, data), [data, selectedObjectType, strategy, strategyProps]);
  const getFilterFamilyOptions = useCallback(() => strategy.getFilterFamilyOptions(strategyProps, selectedObjectType, strategy.isSameObjectAssociationFilteringEnabled), [selectedObjectType, strategy, strategyProps]);
  const getGroupedFilterFamilyOptions = useCallback((filterFamilyGroup, otherProps) => strategy.getGroupedFilterFamilyOptions(strategyProps, filterFamilyGroup, selectedObjectType, strategy.isSameObjectAssociationFilteringEnabled, otherProps), [selectedObjectType, strategy, strategyProps]);
  const getReferenceResolvers = useCallback(filterFamily => {
    let baseResolvers = ImmutableMap({
      ACTIVITY_TYPE: resolvers.get(ReferenceObjectTypes.ACTIVITY_TYPE),
      CALL_DISPOSITION: resolvers.get(ReferenceObjectTypes.CALL_DISPOSITION),
      MEETING_OUTCOME: resolvers.get(ReferenceObjectTypes.MEETING_OUTCOME),
      DEAL_PIPELINE: resolvers.get(ReferenceObjectTypes.DEAL_PIPELINE),
      DEAL_STAGE: resolvers.get(ReferenceObjectTypes.DEAL_PIPELINE_STAGE),
      OWNER: resolvers.get(ReferenceObjectTypes.OWNER),
      PERSONA: resolvers.get(ReferenceObjectTypes.PERSONA),
      SALESFORCE_CAMPAIGN: resolvers.get(ReferenceObjectTypes.SALESFORCE_CAMPAIGN),
      TEAM: resolvers.get(ReferenceObjectTypes.HIERARCHICAL_TEAM),
      USER: resolvers.get(ReferenceObjectTypes.USER),
      [ReferenceObjectTypes.EMAIL_CAMPAIGN]: resolvers.get(ReferenceObjectTypes.EMAIL_CAMPAIGN),
      [ReferenceObjectTypes.EMAIL_CAMPAIGN_URL]: resolvers.get(ReferenceObjectTypes.EMAIL_CAMPAIGN_URL),
      [DSAssetFamilies.ADS_PROPERTY]: resolvers.get(ReferenceObjectTypes.ADS_PROPERTY),
      [DSAssetFamilies.COMPANY_PROPERTY]: resolvers.get(ReferenceObjectTypes.COMPANY_PROPERTY),
      [DSAssetFamilies.CONTACT_PROPERTY]: resolvers.get(ReferenceObjectTypes.CONTACT_PROPERTY),
      [DSAssetFamilies.QUOTE_PROPERTY]: resolvers.get(ReferenceObjectTypes.QUOTE_PROPERTY),
      [DSAssetFamilies.CTA]: resolvers.get(ReferenceObjectTypes.CTA),
      [DSAssetFamilies.DEAL_PROPERTY]: resolvers.get(ReferenceObjectTypes.DEAL_PROPERTY),
      [DSAssetFamilies.EMAIL_SUBSCRIPTION]: resolvers.get(getIsUngated('subscriptions:groupSettings') ? ReferenceObjectTypes.EMAIL_SUBSCRIPTION_GROUPS : ReferenceObjectTypes.EMAIL_SUBSCRIPTION),
      [DSAssetFamilies.SMS_SUBSCRIPTION]: resolvers.get(ReferenceObjectTypes.SMS_SUBSCRIPTION),
      [DSAssetFamilies.WHATSAPP_SUBSCRIPTION]: resolvers.get(ReferenceObjectTypes.WHATSAPP_SUBSCRIPTION),
      [DSAssetFamilies.ENGAGEMENT_PROPERTY]: resolvers.get(ReferenceObjectTypes.ENGAGEMENT_PROPERTY),
      [DSAssetFamilies.LINE_ITEM_PROPERTY]: resolvers.get(ReferenceObjectTypes.LINE_ITEM_PROPERTY),
      [DSAssetFamilies.PRODUCT_PROPERTY]: resolvers.get(ReferenceObjectTypes.PRODUCT_PROPERTY),
      [FiltersReferenceObjectTypes.MARKETING_EVENT_COORDINATES]: resolvers.get(FiltersReferenceObjectTypes.MARKETING_EVENT_COORDINATES),
      [ReferenceObjectTypes.MEDIA_BRIDGE_MEDIA_OBJECT]: resolvers.get(ReferenceObjectTypes.MEDIA_BRIDGE_MEDIA_OBJECT),
      [ReferenceObjectTypes.ADS_FACEBOOK_AD]: resolvers.get(ReferenceObjectTypes.ADS_FACEBOOK_AD),
      [ReferenceObjectTypes.ADS_FACEBOOK_ADGROUP]: resolvers.get(ReferenceObjectTypes.ADS_FACEBOOK_ADGROUP),
      [ReferenceObjectTypes.ADS_FACEBOOK_CAMPAIGN]: resolvers.get(ReferenceObjectTypes.ADS_FACEBOOK_CAMPAIGN),
      [ReferenceObjectTypes.ADS_GOOGLE_AD]: resolvers.get(ReferenceObjectTypes.ADS_GOOGLE_AD),
      [ReferenceObjectTypes.ADS_GOOGLE_ADGROUP]: resolvers.get(ReferenceObjectTypes.ADS_GOOGLE_ADGROUP),
      [ReferenceObjectTypes.ADS_GOOGLE_CAMPAIGN]: resolvers.get(ReferenceObjectTypes.ADS_GOOGLE_CAMPAIGN),
      [ReferenceObjectTypes.ADS_GOOGLE_KEYWORD]: resolvers.get(ReferenceObjectTypes.ADS_GOOGLE_KEYWORD),
      [ReferenceObjectTypes.ADS_LINKEDIN_AD]: resolvers.get(ReferenceObjectTypes.ADS_LINKEDIN_AD),
      [ReferenceObjectTypes.ADS_LINKEDIN_ADGROUP]: resolvers.get(ReferenceObjectTypes.ADS_LINKEDIN_ADGROUP),
      [ReferenceObjectTypes.ADS_LINKEDIN_CAMPAIGN]: resolvers.get(ReferenceObjectTypes.ADS_LINKEDIN_CAMPAIGN),
      [ReferenceObjectTypes.COMPANY]: resolvers.get(ReferenceObjectTypes.COMPANY),
      [ReferenceObjectTypes.CONTACT]: resolvers.get(ReferenceObjectTypes.CONTACT),
      [ReferenceObjectTypes.CUSTOM_OBJECT]: resolvers.get(ReferenceObjectTypes.CUSTOM_OBJECT),
      [ReferenceObjectTypes.MULTI_CURRENCY_CURRENCY_CODE]: resolvers.get(ReferenceObjectTypes.MULTI_CURRENCY_CURRENCY_CODE),
      // HACK: at least one scope related to content access is required to
      // use the values inside FormSubmissions operators but not the whole
      // FormSubmissions family, see LIST-1143.
      [ReferenceObjectTypes.SITE_CONTENT]: hasSiteContentAccess(hasScope) ? resolvers.get(ReferenceObjectTypes.SITE_CONTENT) : FieldResolverNull,
      [ReferenceObjectTypes.TICKET_PIPELINE]: resolvers.get(ReferenceObjectTypes.TICKET_PIPELINE),
      [ReferenceObjectTypes.TICKET_STAGE]: resolvers.get(ReferenceObjectTypes.TICKET_STAGE),
      [DSAssetFamilies.TICKET_PROPERTY]: resolvers.get(ReferenceObjectTypes.TICKET_PROPERTY),
      [ReferenceObjectTypes.FORM]: resolvers.get(ReferenceObjectTypes.FORM),
      [ReferenceObjectTypes.EVENT]: resolvers.get(ReferenceObjectTypes.EVENT),
      [FiltersReferenceObjectTypes.CAMPAIGN_COORDINATES]: resolvers.get(FiltersReferenceObjectTypes.CAMPAIGN_COORDINATES),
      [FiltersReferenceObjectTypes.WEB_INTERACTIVE_COORDINATES]: resolvers.get(FiltersReferenceObjectTypes.WEB_INTERACTIVE_COORDINATES),
      [FiltersReferenceObjectTypes.AUTOMATION_PLATFORM_FLOW_COORDINATES]: resolvers.get(FiltersReferenceObjectTypes.AUTOMATION_PLATFORM_FLOW_COORDINATES),
      [ReferenceObjectTypes.SOCIAL_CHANNEL]: resolvers.get(ReferenceObjectTypes.SOCIAL_CHANNEL),
      // Workflows event trigger resolvers
      AD_CAMPAIGN: resolvers.get(ReferenceObjectTypes.AD_OBJECT_AD_CAMPAIGN),
      AD_GROUP: resolvers.get(ReferenceObjectTypes.AD_OBJECT_AD_GROUP),
      AD: resolvers.get(ReferenceObjectTypes.AD_OBJECT_AD),
      AUTOMATION_PLATFORM_WORKFLOWS: resolvers.get(ReferenceObjectTypes.AUTOMATION_PLATFORM_WORKFLOWS),
      CTA_GUID: resolvers.get(ReferenceObjectTypes.CTA_GUID),
      WEB_INTERACTIVE: resolvers.get(ReferenceObjectTypes.WEB_INTERACTIVE),
      EMAIL: resolvers.get(ReferenceObjectTypes.EMAIL)
      // eof Workflows event trigger resolvers
    });

    // add dynamic reference resolver for custom objects
    // (see https://git.hubteam.com/HubSpot/customer-data-filters-ui/LibraryCopy/pull/928)
    if (CustomObjectTypeIdRegex.test(filterFamily)) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      let coResolver = dynamicResolvers[filterFamily];
      if (!coResolver) {
        coResolver = AllObjectPropertiesReferenceResolver(filterFamily, {})(() => makeAtom());

        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        dynamicResolvers[filterFamily] = coResolver;
      }
      baseResolvers = baseResolvers.set(filterFamily, coResolver);
    }
    const strategyResolvers = strategy.getReferenceResolvers(resolvers,
    // @ts-expect-error ts-migrate(7053) FIXME
    filterFamily);
    return baseResolvers.mergeWith((baseResolver, strategyResolver) => strategyResolver || baseResolver, strategyResolvers);
  }, [resolvers, getIsUngated, hasScope, strategy]);
  const PropertyNameToReferenceTypeForAllObjects = useMemo(() => ({
    hubspot_team_id: TeamReferenceObjectType
  }), []);
  const getReferenceType = useCallback((filterFamily, name) => {
    const propertyObjectType = DSAssetFamilyToObjectType.get(filterFamily) || filterFamily;
    return PropertyNameToReferenceTypeForAllObjects[name] || getIn([propertyObjectType, name], PropertyNameToReferenceType);
  }, [PropertyNameToReferenceTypeForAllObjects]);
  const getReferenceTypeForOperator = useCallback((operator, filterFamily) => {
    switch (operator.constructor) {
      case Operators.After:
      case Operators.Before:
      case Operators.UpdatedAfter:
      case Operators.UpdatedBefore:
        return filterFamily;
      case Operators.CtaHasClicked:
      case Operators.CtaHasNotClicked:
      case Operators.CtaHasNotSeen:
      case Operators.CtaHasSeen:
        return DSAssetFamilies.CTA;
      case Operators.EmailLinkClicked:
        return ReferenceObjectTypes.EMAIL_CAMPAIGN_URL;
      case Operators.EmailSubscriptionNotOpted:
      case Operators.EmailSubscriptionOptIn:
      case Operators.EmailSubscriptionOptOut:
        return DSAssetFamilies.EMAIL_SUBSCRIPTION;
      case Operators.FormFilledOut:
      case Operators.FormNotFilledOut:
        return ReferenceObjectTypes.SITE_CONTENT;
      case Operators.PropertyNameAndValue:
        return operator.referencedObjectTypeId;
      default:
        return null;
    }
  }, []);
  const getReferencedObjectType = useCallback((filterFamily, condition) => {
    const {
      name
    } = condition.field;
    const fieldDefinitions = hasFieldOverrideV2(getIsUngated) ? ImmutableMap({}) : strategy.getFieldDefinitions(filterFamily);
    return getReferenceTypeForOperator(condition, filterFamily || baseFilterFamily) || getIn([name, 'referencedObjectType'], fieldDefinitions) || getIn(['field', 'referencedObjectType'], condition) || getReferenceType(filterFamily || baseFilterFamily, name) || null;
  }, [baseFilterFamily, strategy, getReferenceTypeForOperator, getReferenceType, getIsUngated]);
  const getValueResolver = useCallback((filterFamily, operator) => {
    var _operator$field, _operator$field2;
    // TEAM reference fields must use a ReferenceResolver that is compatible
    // with the FilterOperatorTeamInput and DisplayValueEntity components
    if (((_operator$field = operator.field) === null || _operator$field === void 0 ? void 0 : _operator$field.get('externalOptionsReferenceType')) === TeamExternalOptionType || ((_operator$field2 = operator.field) === null || _operator$field2 === void 0 ? void 0 : _operator$field2.get('referencedObjectType')) === TeamReferenceObjectType) {
      const referenceResolvers = getReferenceResolvers(filterFamily);
      return getIn([TeamReferenceObjectType], referenceResolvers);
    }
    if (isExternalOptionsField(operator.field, filterFamily, getIsUngated) && operatorSupportsExternalOptions(operator)) {
      return getPropertyResolver({
        property: operator.field,
        objectTypeId: filterFamily
      });
    }
    const referenceResolvers = getReferenceResolvers(filterFamily);
    const key = getReferencedObjectType(filterFamily, operator);
    return getIn([key], referenceResolvers);
  }, [getReferenceResolvers, getReferencedObjectType, getIsUngated]);
  const getSpecialOptionsForReferenceType = useCallback((referenceType, filterFamily) => {
    const specialOptionsByReferenceType = strategy.getSpecialFieldOptions();
    if (Object.prototype.hasOwnProperty.call(specialOptionsByReferenceType, referenceType)) {
      const getOptions = specialOptionsByReferenceType[referenceType];
      return getOptions(filterFamily);
    }
    return undefined;
  }, [strategy]);
  const getObjectAssociationOptions = assetFamily => {
    const options = strategy.getObjectAssociationOptions(assetFamily, baseFilterFamily, data, ASSOCIATION_DIRECTION.STANDARD);
    return alphabetizeAssociationOptions(options);
  };
  const getObjectInverseAssociationOptions = assetFamily => {
    const options = strategy.getObjectAssociationOptions(assetFamily, baseFilterFamily, data, ASSOCIATION_DIRECTION.INVERSE);
    return alphabetizeAssociationOptions(options);
  };
  const shouldSelectTheOnlyFieldAutomatically = filterFamily => {
    const filterFamiliesToSelectAutomatically = [DSAssetFamilies.EMAIL_SUBSCRIPTION, DSAssetFamilies.SMS_SUBSCRIPTION, DSAssetFamilies.WHATSAPP_SUBSCRIPTION, DSAssetFamilies.PAGE_VIEW];
    return filterFamiliesToSelectAutomatically.includes(filterFamily);
  };
  const getCustomFilterFamilyFieldsGroup = useCallback(filterFamily => {
    if (filterFamily === DSAssetFamilies.EVENT) {
      return PropertyGroupRecord({
        displayName: I18n.text(`newCustomerDataFilters.specialGroups.EVENT.behavioral_events`),
        name: 'behavioral_events'
      });
    }
    if (filterFamily === DSAssetFamilies.CTA) {
      return PropertyGroupRecord({
        displayName: I18n.text(`newCustomerDataFilters.specialGroups.CTA.calls_to_action`),
        name: 'calls_to_action'
      });
    }
    if (filterFamily === DSAssetFamilies.FORM) {
      return PropertyGroupRecord({
        displayName: I18n.text(`newCustomerDataFilters.specialGroups.FORM.forms`),
        name: 'forms'
      });
    }
    if (filterFamily === DSAssetFamilies.EMAIL_CAMPAIGN) {
      return PropertyGroupRecord({
        displayName: I18n.text(`newCustomerDataFilters.specialGroups.EMAIL_CAMPAIGN.email_campaigns`),
        name: 'email_campaigns'
      });
    }
    return undefined;
  }, []);
  const validateCondition = (condition, options) => strategy.validateOperator(condition, getIsUngated, options);
  const isFiscalYearEnabled = useMemo(() => {
    return strategy.getIsFiscalYearEnabled();
  }, [strategy]);
  const isRollingDateOffsetInputEnabled = useMemo(() => {
    return strategy.getIsRollingDateOffsetInputEnabled(hasScope);
  }, [hasScope, strategy]);
  return {
    getFieldDefinitions: strategy.getFieldDefinitions,
    getFieldGroups,
    getEnabledAssociatedObjectTypeIds,
    getRefinementFieldGroups,
    getRefinementFields: strategy.getRefinementFields,
    getField,
    getFields,
    getRequiredFields,
    getFilterFamilyGroupHeading,
    getFilterFamilyName,
    getFilterFamilyObjectName,
    getFilterFamilyOptions,
    getGroupedFilterFamilyOptions,
    getOperatorsForType: strategy.getOperatorsForType,
    getReferenceResolvers,
    getReferenceType,
    getReferenceTypeForOperator,
    getSpecialFieldOptions: strategy.getSpecialFieldOptions,
    getReferencedObjectType,
    getValueResolver,
    getSpecialOptionsForReferenceType,
    getObjectAssociationOptions,
    getObjectInverseAssociationOptions,
    shouldSelectTheOnlyFieldAutomatically,
    getCustomFilterFamilyFieldsGroup,
    getDefaultTimezone: strategy.getDefaultTimezone,
    getTimezoneOptions: strategy.getTimezoneOptions,
    strategyType: strategy.strategyType,
    validateCondition,
    isIncludeObjectsWithNoValueSetCheckboxEnabled: strategy.isIncludeObjectsWithNoValueSetCheckboxEnabled,
    isFiscalYearEnabled,
    isRollingDateOffsetInputEnabled,
    conditionsPerORGroupLimit: strategy.conditionsPerORGroupLimit,
    evaluateFiltersForObject: strategy.evaluateFiltersForObject,
    isSameObjectAssociationFilteringEnabled: strategy.isSameObjectAssociationFilteringEnabled,
    isTestFiltersEnabled: strategy.isTestFiltersEnabled,
    isNotCompletedUnifiedEventFiltersEnabled: strategy.isNotCompletedUnifiedEventFiltersEnabled,
    useHoursFiltering: strategy.useHoursFiltering
  };
}